import * as React from 'react'
import { Box } from "@mui/material"


export default function skuColumn() {
	return {
		name: 'sku', label: 'SKU',
		options: {
			headerAlign: 'left',
			setCellProps: () => ({ sx: { minWidth: '150px' }}),
			customBodyRowRenderLite: value => <Box>
				{value}
			</Box>
		}
	}
}